import "core-js/modules/es.number.constructor.js";
export var BASE_USER_EMAILS_KEY = 'user-emails';
var userEmailsKeys = {
  userEmails: function userEmails(userId) {
    return [BASE_USER_EMAILS_KEY, userId ? Number(userId) : 'me'];
  }
};
export default userEmailsKeys;